

import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import { routes } from "./routes/index";
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    treeStore: []
  },
  mutations: {
    updateTreeStore(state, newTree) {
      console.log(state.treeStore)
      state.treeStore = newTree
    }
  },
  actions: {
    updateTree(context, tree) {
      console.log(tree)
      context.commit('updateTreeStore', tree)
    }
  },
  getters: {
    tree(state) {
      return state.treeStore
    }
  }
})

Vue.use(VueAxios, axios)
Vue.use(VueRouter)


Vue.config.productionTip = false
const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
